<template>
  <div class="row">
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 detail">
      <span>รหัสไปรษณีย์*</span>
      <el-select
        :value="addressForm.zip_code"
        @input="handleChangeAddressForm('zip_code', $event)"
        clearable
        filterable
        remote
        :remote-method="handleSearchZipCode"
      >
        <el-option v-for="code in zipCodes" :value="code" :key="code">{{
          code
        }}</el-option>
      </el-select>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 detail">
      <span>จังหวัด*</span>
      <el-select
        :value="addressForm.province_code"
        @input="handleChangeAddressForm('province_code', $event)"
        value-key="province_code"
        label-key="provice_name"
      >
        <el-option
          v-for="p in provinces"
          :value="p.province_code"
          :label="p.province_name"
          :key="p.province_code"
          >{{ p.province_name }}</el-option
        >
      </el-select>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 detail">
      <span>เขต/อำเภอ*</span>
      <el-select
        :value="addressForm.amphur_code"
        @input="handleChangeAddressForm('amphur_code', $event)"
      >
        <el-option
          v-for="a in amphurs"
          :value="a.amphur_code"
          :label="a.amphur_name"
          :key="a.amphur_code"
          >{{ a.amphur_name }}</el-option
        >
      </el-select>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 detail">
      <span>แขวง/ตำบล*</span>
      <el-select
        v-model="addressForm.tumbon"
        :value="addressForm.tumbon"
        @input="handleChangeAddressForm('tumbon', $event)"
        value-key="tumbon_code"
        label-key="tumbon_name"
      >
        <el-option
          v-for="t in selectableTumbons"
          :value="t"
          :label="t.tumbon_name"
          :key="t.tumbon_code"
          >{{ t.tumbon_name }}</el-option
        >
      </el-select>
    </div>
    <div class="col-12 detail">
      <span>ที่อยู่*</span>
      <el-input
        type="textarea"
        :value="addressForm.address"
        @input="handleChangeValue('address', $event)"
      ></el-input>
    </div>
  </div>
</template>

<script>
import { Input, Autocomplete, Select, Option } from "element-ui";
import { baanRueJaiClient } from "@/dependencies";
import * as R from "ramda";

// Validation function that checks if all required properties are present
function isValid(obj) {
  return (
    obj.amphur_code &&
    obj.amphur_name &&
    obj.amphur_name_en &&
    obj.pre_amphur &&
    obj.pre_amphur_en &&
    obj.pre_tumbon &&
    obj.pre_tumbon_en &&
    obj.province_code &&
    obj.province_name &&
    obj.province_name_en &&
    obj.tumbon_code &&
    obj.tumbon_name &&
    obj.tumbon_name_en &&
    obj.zip_code
  );
}

export default {
  components: {
    "el-input": Input,
    "el-autocomplete": Autocomplete,
    "el-select": Select,
    "el-option": Option,
  },
  props: [],
  data() {
    const addressForm = {
      zip_code: null,
      province_code: null,
      amphur_code: null,
      tumbon: null,
      address: null,
    };

    return {
      addressForm,
      initialTumbons: [],
      searchTumbons: null,
    };
  },
  computed: {
    tumbons() {
      return this.searchTumbons || this.initialTumbons;
    },
    zipCodes() {
      if (!this.tumbons.length) {
        return [];
      }

      // Get unique objects based on zip_code
      const uniqueArr = this.tumbons.filter(
        (obj, index, self) =>
          index === self.findIndex((o) => o.zip_code === obj.zip_code)
      );

      // Filter out invalid objects
      const filteredArr = uniqueArr.filter(isValid);

      return R.pipe(R.map(R.path(["zip_code"])), R.uniq)(filteredArr);
    },
    provinces() {
      return R.uniqBy(R.path(["province_code"]), this.tumbons);
    },
    amphurs() {
      if (!this.addressForm.province_code) {
        return [];
      }

      const uniqueProvinceAndZipcodeArr = this.tumbons.filter(
        (tumbon) => tumbon.province_code === this.addressForm.province_code
        && tumbon.zip_code === this.addressForm.zip_code
      )

      return R.pipe(
        R.filter(R.propEq("province_code", this.addressForm.province_code)),
        R.uniqBy(R.path(["amphur_code"]))
      )(uniqueProvinceAndZipcodeArr);
    },
    selectableTumbons() {
      if (!this.addressForm.amphur_code) {
        return [];
      }

      return this.tumbons.filter(({ amphur_code, zip_code }) => {
        return (
          amphur_code === this.addressForm.amphur_code &&
          zip_code === this.addressForm.zip_code
        );
      });
    },
  },
  watch: {},
  methods: {
    async setup() {
      await this.setupData();
      await this.setupForm();
    },
    async setupForm() {},
    async setupData() {
      await this.setupInitialTumbons();
    },
    async handleChangeAddressForm(key, value) {
      this.addressForm[key] = value;

      switch (key) {
        case "zip_code":
          this.handleChangeAddressZipCodeForm(value);
        case "amphur_code":
          this.handleChangeAddressAmphurCodeForm(value);
        default:
          break;
      }

      this.$emit("input", {
        ...this.addressForm
      });
    },
    async handleChangeAddressZipCodeForm(val) {
      if (!val) {
        this.addressForm.province_code = null;
        this.addressForm.amphur_code = null;
        this.addressForm.tumbon = null;
        return;
      }

      switch (this.provinces.length) {
        case 1:
          this.addressForm.province_code = this.provinces[0].province_code;
          break;
        default:
          this.addressForm.province_code = null;
          break;
      }

      switch (this.amphurs.length) {
        case 1:
          this.addressForm.amphur_code = this.amphurs[0].amphur_code;
          break;
        default:
          this.addressForm.amphur_code = null;
          break;
      }

      switch (this.selectableTumbons.length) {
        case 1:
          this.addressForm.tumbon = this.selectableTumbons[0];
          break;
        default:
          this.addressForm.tumbon = null;
          break;
      }
    },
    async handleChangeAddressAmphurCodeForm(val) {
      if (!val) {
        return;
      }

      switch (this.selectableTumbons.length) {
        case 1:
          this.addressForm.tumbon = this.selectableTumbons[0];
          break;
        default:
          this.addressForm.tumbon = null;
          break;
      }
    },
    async handleSearchZipCode(queryString) {
      const params = { zip_code: queryString };
      const response = await baanRueJaiClient.admin.addresses.list(params);

      this.searchTumbons = response.data.result;
    },
    async setupInitialTumbons() {
      const params = { zip_code: this.rawReceipt.home.zip_code };
      const response = await baanRueJaiClient.admin.addresses.list(params);

      this.initialTumbons = response.data.result;
    },
    handleChangeValue(key, value) {
      this.addressForm[key] = value;

      const params = {
        ...this.addressForm,
        [key]: value
      }

      this.$emit("input", params);
    }
  },
};
</script>

<style lang="scss" scoped>
.label {
  font-size: 14px;
  color: #777;
}

.detail {
  padding-top: 10px;
}

.el-select,
el-select,
el-option {
  width: 100%;
}

span {
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/lib/components/AddressAutoFillSelector.vue